import React, {useEffect, useCallback} from 'react';
import {observer} from 'mobx-react';
import s from '../s';
import * as util from '../../util';
import * as emitter from '../../global/emitter';

declare var _is_caf: boolean;

const ProductHeader: React.FC = observer(() => {
    const [, forceUpdate] = React.useReducer(x => x + 1, 0);

    useEffect(() => {
        const abForceUpdate = async () => forceUpdate();
        emitter.eventEmitter.subscribe(emitter.EventType.AB, 'ab', abForceUpdate);
        return () => {
            emitter.eventEmitter.unsubscribe(emitter.EventType.AB, 'ab');
        };
    }, []);

    const goReviews = useCallback(async () => {
        const d = document.getElementById('prod-reviews') as HTMLDivElement;
        const d2 = document.getElementById('prod-reviews-click') as HTMLDivElement;
        if (d2) {
            d2.click();
        }
        setTimeout(function () {
            if (d) {
                d.scrollIntoView();
            }
        }, 100);
    }, []);

    if (!s.si) return null;

    return (
        <div id="prod-header">
            <div>
                {s.prod && s.si && (!s.si.ManualOverride_Desc || s.si.ManualOverride_Desc.length <= 5) && (
                    <h1 className={s.ui.product_title.length > 100 ? 'h1-xs' : s.ui.product_title.length > 70 ? 'h1-sm' : ''}>
                        {s.prod && (s.prod.IsCAF || !s.prod.TitleShowInstName) ? '' : `${s.si.InstName} `}
                        {s.ui.product_title}
                    </h1>
                )}
                {s.prod && s.si && s.si.ManualOverride_Desc && s.si.ManualOverride_Desc.length > 5 && <h1 className={s.ui.product_title.length > 100 ? 'h1-xs' : s.ui.product_title.length > 70 ? 'h1-sm' : ''}>{s.si.ManualOverride_Desc}</h1>}

                <div id="prod-sub-titles">
                    {!util.isNullOrWhiteSpace(s.ui.sku) && <span className="sku">SKU: {s.ui.sku}</span>}
                    {!s.ps.is_caf && <span className="item-id">Item #: {s.ui.item_id.replace('215873-', 'P')}</span>}

                    {s.ui.allow_reviews && s.ui.review_count > 0 && (
                        <div
                            id="yotpo-prod-header"
                            onClick={goReviews}
                        >
                            <a
                                href="#reviews"
                                aria-label="Reviews"
                            >
                                <div className="prod-yotpo-stars">
                                    <span
                                        className={`fa fa-star ${s.ui.review_score > 0 ? 'yotpo-checked' : ''}`}
                                        role="presentation"
                                    ></span>
                                    <span
                                        className={`fa fa-star ${s.ui.review_score > 1 ? 'yotpo-checked' : ''}`}
                                        role="presentation"
                                    ></span>
                                    <span
                                        className={`fa fa-star ${s.ui.review_score > 2 ? 'yotpo-checked' : ''}`}
                                        role="presentation"
                                    ></span>
                                    <span
                                        className={`fa fa-star ${s.ui.review_score > 3 ? 'yotpo-checked' : ''}`}
                                        role="presentation"
                                    ></span>
                                    <span
                                        className={`fa fa-star ${s.ui.review_score > 4 ? 'yotpo-checked' : ''}`}
                                        role="presentation"
                                    ></span>
                                    <span className="yotpo-star-count">({s.ui.review_count})</span>
                                </div>
                            </a>
                        </div>
                    )}
                </div>
            </div>
            <div className="hide-sm">
                {s.ui.show_pricing && s.ui.price !== s.ui.price_discount && (
                    <div>
                        <span className={`msrp-disc`}>{util.currency(s.ui.price_discount)}</span>
                        <span className={`msrp-orig`}><del>{util.currency(s.ui.price)}</del></span>
                    </div>
                )}
                {s.ui.show_pricing && s.ui.price === s.ui.price_discount && (
                    <div>
                        <span className={`msrp-disc`}>{util.currency(s.ui.price)}</span>
                    </div>
                )}
            </div>
        </div>
    );
});

export default ProductHeader;
